var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayValue)?_c('el-tag',_vm._b({attrs:{"type":_vm.tagType}},'el-tag',_vm.attrs,false),[_vm._v(_vm._s(_vm.displayValue))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }